<template>
  <PersonalAreaTemplate :editing="editing" block-margin-top="50px">
    <div class="basic">
      <div class="photo">
        <ImageFullModal
          v-if="basicData.photoBase64 || basicData.photo"
          :editing="editing"
          :maxHeight="250"
          :minImg="
            basicData.photoBase64 ? basicData.photoBase64 : apiDomain + '/min/' + basicData.photo
          "
          :maxImg="
            basicData.photoBase64 ? basicData.photoBase64 : apiDomain + '/' + basicData.photo
          "
          :avatar="true"
        />
        <div v-else class="no_photo">
          {{ localStorage.translations.pages.common.text['net-foto'] }}
        </div>
        <template v-if="editing">
          <input type="file" ref="file" accept=".jpg, .jpeg, .png" v-on:change="handleFileUpload" />
          <BaseTooltip
            customClass="test"
            :tooltip="
              basicData.photoBase64 || basicData.photo
                ? localStorage.translations.pages.common.buttons['obnovit-fotografiyu']
                : localStorage.translations.pages.common.buttons['zagruzit-fotografiyu']
            "
          >
            <BaseButton
              round
              icon_only
              default_icon="button-upload"
              icon-width="18"
              size="60"
              @click="onFileSelect"
            />
          </BaseTooltip>
        </template>
      </div>
      <v-form ref="form" class="form" v-model="valid" lazy-validation>
        <BaseInput
          :label="localStorage.translations.pages['setting-personal_area'].labels['imya']"
          :view="!editing"
          :rules="['required']"
          v-model="basicData.first_name"
          copy
        />
        <BaseInput
          :label="localStorage.translations.pages['setting-personal_area'].labels['familiya']"
          :view="!editing"
          :rules="['required']"
          v-model="basicData.last_name"
          copy
        />
        <BaseInput
          :label="
            localStorage.translations.pages['setting-personal_area'].labels['elektronnaya-pochta']
          "
          disabled
          v-model="basicData.email"
          :link="!editing && !!basicData.email"
          :hide-details="true"
          link-type="mail"
          :copy="!!basicData.email"
        />
        <BaseInput
          type="date-picker"
          :label="
            localStorage.translations.pages['setting-personal_area'].labels['data-rozhdeniya']
          "
          v-model="basicData.dateBirthday"
          :view="!editing"
          :view-value="basicData.dateBirthday ? $formatDate(basicData.dateBirthday) : '-'"
        />
        <BaseInput
          v-model="basicData.gender"
          type="select"
          :items="genderList"
          :item-text="(i) => i.text"
          :item-value="(i) => i.value"
          :label="
            localStorage.translations.pages['setting-personal_area'].labels.gender || 'Gender'
          "
          placeholder="—"
          :view="!editing"
          :view-value="basicData.gender ? genderList.find((i) => i.value === basicData.gender).text : '-'"
        />
        <BaseInput
          v-for="(i, index) in basicData.phone"
          :key="index"
          type="tel"
          v-model="basicData.phone[index]"
          :label="
            localStorage.translations.pages['setting-personal_area'].labels[
              index === 0 ? 'telefon' : 'dop-telefon'
            ]
          "
          :rules="index === 0 ? ['required'] : []"
          :readonly="!editing"
          :link="!editing"
          link-type="tel"
          copy
        />
        <BaseButton
          v-if="editing && basicData.phone.length <= 4"
          @click="addPhone"
          :text="localStorage.translations.pages['setting-personal_area'].buttons['dobavit']"
          icon="add"
        >
          <template v-slot:icon>
            <AddPhone class="icon" />
          </template>
        </BaseButton>
      </v-form>
    </div>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'
import AddPhone from 'components/icons/personalArea/AddPhone'
import ImageFullModal from 'components/ImageFullModal'
import BaseInput from 'components/base/BaseInput'

export default {
  name: 'BasicData',
  components: {
    BaseInput,
    AddPhone,
    ImageFullModal,
    PersonalAreaTemplate,
  },
  props: { userData: Object, editing: Boolean },
  data: () => ({
    valid: true,
    basicData: {
      last_name: null,
      first_name: null,
      email: null,
      phone: [],
      photo: null,
      dateBirthday: null,
      photoBase64: null,
      gender: 'male',
    },
    items: [],
    file: null,
    menu1: false,
  }),
  mounted() {
    this.onActualData()
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    genderList() {
      return [
        {
          text: this.localStorage.translations.pages['setting-personal_area'].labels.male || 'Male',
          value: 'male',
        },
        {
          text:
            this.localStorage.translations.pages['setting-personal_area'].labels.female || 'Female',
          value: 'female',
        },
        {
          text:
            this.localStorage.translations.pages['setting-personal_area'].labels.other || 'Other',
          value: 'other',
        },
      ]
    },
  },
  watch: {
    userData() {
      this.onActualData()
    },
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    basicData: {
      deep: true,
      handler() {
        this.onNavigationGuardianCheck({
          data: { basicData: this.basicData },
          overwrite: false,
        })
      },
    },
  },
  methods: {
    ...mapActions('user', ['updateUser']),
    ...mapActions('commonUser', ['onCommonUserUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onFileSelect() {
      const input = this.$refs.file
      input.click()
    },
    onActualData() {
      if (this.userData) {
        this.basicData.last_name = this.userData.last_name
        this.basicData.first_name = this.userData.first_name
        this.basicData.email = this.userData.email
        this.basicData.phone = this.userData.phone ? this.userData.phone : ['']
        this.basicData.photo = this.userData.photo
        this.basicData.dateBirthday = this.userData.dob
        this.basicData.gender = this.userData.gender
      }
      this.onNavigationGuardianCheck({
        data: { basicData: this.basicData },
        overwrite: true,
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.validate()) {
          await this.submitFile()
          if (this.$checkNavigationGuardianChange('basicData')) {
            this.onCheckingAndDeletingEmptyPhones()
            let data = {
              last_name: this.basicData.last_name,
              first_name: this.basicData.first_name,
              email: this.basicData.email,
              phone: this.basicData.phone,
              dob: this.basicData.dateBirthday,
              photo: this.basicData.photo,
              gender: this.basicData.gender,
            }
            if (this.$route.name === 'PersonalAreaEmployeeEdit') {
              data.id = this.userData.id
            }
            this[this.$route.name === 'PersonalAreaEdit' ? 'updateUser' : 'onCommonUserUpdate'](
              data,
            )
              .then((resp) => {
                resolve(resp)
              })
              .catch((err) => {
                reject(err)
              })
          } else resolve(true)
        } else reject(false)
      })
    },
    validate() {
      return this.$refs.form.validate()
    },
    onCheckingAndDeletingEmptyPhones() {
      for (let i in this.basicData.phone) {
        if (this.basicData.phone[0] !== this.basicData.phone[i]) {
          if (this.basicData.phone[i] === null || !this.basicData.phone[i].length) {
            this.basicData.phone.splice(i, 1)
          }
        }
      }
    },
    addPhone() {
      if (this.basicData.phone !== null) {
        this.basicData.phone.push('')
      } else {
        this.basicData.phone = ['']
      }
    },
    save(date) {
      this.$refs.menu1.save(date)
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async submitFile() {
      if (this.file) {
        let formData = new FormData()
        formData.append('file', this.file)
        if (this.userData.photo) {
          this.$store.dispatch('deleteFile', {
            url: this.userData.photo,
          })
        }
        await this.$store
          .dispatch('uploadFile', {
            data: formData,
            use_case: 'cover',
          })
          .then((response) => {
            this.basicData.photo = response.data.url
          })
          .catch()
      }
    },
    async handleFileUpload(e) {
      const file = e.target.files[0]
      this.file = file
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.basicData.photoBase64 = reader.result
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.phone_container {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  align-items: end;
}
.basic {
  display: grid;
  grid-template-columns: 250px auto;
  grid-column-gap: 30px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 1fr;
    //justify-items: center;
  }

  :deep() .photo {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 250px;
    max-width: 250px;
    width: 100%;
    border-radius: 10px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      margin: 0 auto 12px;
    }
    .v-image,
    .no_photo {
      box-shadow: 0px 4px 4px rgba(133, 133, 133, 0.25);
      border-radius: 10px;
      z-index: 0;
    }
    .no_photo {
      width: 100%;
      height: 100%;
      display: grid;
      padding: 5px;
      align-items: center;
      justify-content: center;
      transition: 0.3s;
      border-radius: 10px;
      background: #277faf;
      color: #ffffff;
    }
    .test {
      position: absolute;
      right: -25px;
      bottom: -25px;
    }
    input {
      display: none;
    }
  }

  .form {
    background-color: white;
    border-radius: 4px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-template-rows: max-content max-content;
    grid-column-gap: 20px;
    grid-row-gap: 10px;
    align-items: end;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      padding: 0;
      border: none;
      background-color: transparent;
      grid-template-columns: 1fr;
    }
  }

  .customBtn {
    height: max-content;
  }
}
</style>
